import React, { useCallback } from "react";

import {
    Box,
    FormHelperText,
    IconButton,
    Slider,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { isEmpty } from "lodash";

const SliderWithButtons = ({
    title,
    value,
    onChange,
    unit,
    disabled,
    minValue,
    maxValue,
    step = 1,
    helperText,
    name,
}) => {
    let strValue = value;
    if (!isNaN(value)) {
        strValue = `${value}`;
    }
    let numValue = value;
    if (isNaN(numValue)) {
        numValue = 0;
    } else {
        numValue = value * 1;
    }

    if (minValue !== undefined && value === undefined) {
        strValue = "" + minValue;
        numValue = minValue;
    }

    const handleChange = useCallback(
        (e) => {
            onChange && onChange(e);
        },
        [onChange]
    );

    const handleButtonChange = useCallback(
        (step) => () => {
            handleChange({ target: { name, value: numValue + step } });
        },
        [handleChange, name, numValue]
    );

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    justifyContent: "space-between",
                }}>
                <Typography variant="subtitle1" color={disabled ? "text.disabled" : "text.primary"}>
                    {title}
                </Typography>
                <TextField
                    onChange={handleChange}
                    value={strValue}
                    name={name}
                    disabled={disabled}
                    margin="normal"
                    size="small"
                    fullWidth
                    InputProps={{ endAdornment: isEmpty(unit) ? undefined : ` ${unit}` }}
                    inputProps={{ style: { textAlign: "right" } }}
                    sx={{ width: 120 }}
                />
            </Box>
            <Stack spacing={2} direction="row">
                <IconButton
                    size="small"
                    disabled={disabled || !value}
                    onClick={handleButtonChange(-step)}>
                    <RemoveOutlinedIcon fontSize="inherit" />
                </IconButton>
                <Slider
                    value={numValue || 0}
                    onChange={handleChange}
                    valueLabelDisplay="auto"
                    step={step}
                    min={minValue || 0}
                    max={maxValue || 0}
                    disabled={disabled}
                    name={name}
                />
                <IconButton
                    size="small"
                    disabled={disabled || value >= maxValue}
                    onClick={handleButtonChange(step)}>
                    <AddOutlinedIcon fontSize="inherit" />
                </IconButton>
            </Stack>
            {!!helperText && <FormHelperText>Maximální doba trvání položky výkazu</FormHelperText>}
        </>
    );
};

export default SliderWithButtons;
